import restRequestV3 from '@/utils/restRequestV3'

const BASE_URL = '/api/v3/store-cart'

export default {
  /**
   * 获取当前用户购物车列表（按店铺分组，并附加优惠券）
   * @param {Object} params 查询参数
   * @param {Number} params.userId 用户ID（可选）
   * @param {Number} params.storeId 店铺ID（可选）
   * @param {String} params.productName 商品名称（可选）
   * @param {Number} params.productId 商品ID（可选）
   * @param {Number} params.resourceId 资源ID（可选）
   * @returns {Promise<Array>} 按店铺分组的购物车列表
   */
  list(params = {}) {
    return restRequestV3.post(`${BASE_URL}/list`, params)
  },

  /**
   * 创建购物车条目
   * @param {Object} params 创建参数
   * @param {Number} params.userId 用户ID（可选）
   * @param {String} params.openid 用户OpenID（可选）
   * @param {Number} params.resourceId 资源ID（可选）
   * @param {Number} params.productId 商品ID（必填）
   * @param {Number} params.productNum 商品数量（必填）
   * @param {String} params.remark 备注（可选）
   * @returns {Promise<Object>} 创建的购物车条目
   */
  create(params) {
    return restRequestV3.post(`${BASE_URL}/create`, params)
  },

  /**
   * 增加购物车条目数量
   * @param {Object} params 更新参数
   * @param {Number} params.storeCartId 购物车ID（必填）
   * @param {Number} params.quantity 增加数量（默认为1）
   * @returns {Promise<Object>} 更新后的购物车条目
   */
  increaseQuantity(params) {
    return restRequestV3.post(`${BASE_URL}/increase-quantity`, params)
  },

  /**
   * 减少购物车条目数量
   * @param {Object} params 更新参数
   * @param {Number} params.storeCartId 购物车ID（必填）
   * @param {Number} params.quantity 减少数量（默认为1）
   * @returns {Promise<Object>} 更新后的购物车条目
   */
  decreaseQuantity(params) {
    return restRequestV3.post(`${BASE_URL}/decrease-quantity`, params)
  },

  /**
   * 删除购物车条目
   * @param {Number} storeCartId 购物车ID
   * @returns {Promise<String>} 删除结果
   */
  delete(storeCartId) {
    return restRequestV3.post(`${BASE_URL}/delete/${storeCartId}`)
  },

  /**
   * 获取购物车详情
   * @param {Number} storeCartId 购物车ID
   * @returns {Promise<Object>} 购物车详情
   */
  detail(storeCartId) {
    return restRequestV3.get(`${BASE_URL}/detail/${storeCartId}`)
  },

  /**
   * 提交购物车生成订单
   * @param {Object} params 提交参数
   * @param {Array} params.storeCartIds 购物车ID列表（必填）
   * @param {Boolean} params.useCoupon 是否使用优惠券（默认true）
   * @param {Number} params.couponId 优惠券ID（可选）
   * @param {Number} params.receiptType 收货方式【0：自提，1：快递】（必填）
   * @param {String} params.consigneeName 收货人姓名（可选）
   * @param {String} params.consigneePhone 收货人电话（可选）
   * @param {String} params.consigneeAddress 收货地址（可选）
   * @param {String} params.remark 备注（可选）
   * @param {Number} params.resourceId 资源ID（可选）
   * @returns {Promise<Object>} 创建的订单信息
   */
  submit(params) {
    return restRequestV3.post(`${BASE_URL}/submit`, params)
  },

  /**
   * 获取当前用户购物车有效总数
   * @returns {Promise<Number>} 购物车有效总数
   */
  count() {
    return restRequestV3.post(`${BASE_URL}/count`)
  }
}


// WEBPACK FOOTER //
// ./src/api/v3/storeCart.js